export default {
    user: null,   
    idUser: null, 
    isLogged: false,        
    error: false,
    errorMessage: '',
    isLoadingAuth: false,
    token: null,      
}